export const IconMap = {
  vip: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IllQRkpWRklKSVdIUDRFUTNQWlhXWUVWRzdQNTc0USIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjgyNzk2NzAyODU1ODU5OTE2fQ.webp',
  match:
    'https://cdn.duetapp.net/v1/images/eyJpZCI6IlZPUFBISlgyREJHUDVDV1o0UFNJQTMzRTJFSFdKWSIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjQ4MDIzMzk4NjI5Mzc0NDc3NDR9.png',
  swip: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IllNVVVaNFMyRlZKSkVSSEE0QzJOVVI0R0dIWVNKViIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE2Njk1NTI3ODQwODgwNDUzMjd9.png',
  conversations:
    'https://cdn.duetapp.net/v1/images/eyJpZCI6IjU3WDZUN0xOWkZRTTNLVVlZQ1JVR0xFQVFEQ0xVUiIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjYyNTI4MjUzNDc0MDE3NTM2OH0.png',
  me: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkNZVkdLVDVXMlpOMjZRV0EyWkxMNjRIVVAyUlhFVSIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE2MTQ5NDYyNDY1NzcyNjIxNTd9.webp',
};

export const IconMapLight = {
  vip: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IjdZNVhLQVVZQzJQQUkyRzc0U09CTURESFpQWU5NUyIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjc4MjkzMzg2ODM4OTM3MTY0fQ.webp',
  swip: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkZJRFRNR0U2UEszRElWV0c1NExVTFozTjRSU0YyTCIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE2NTgyOTM3ODQ4ODY3MDY5NTl9.png',
  match:
    'https://cdn.duetapp.net/v1/images/eyJpZCI6IjQzMk5MMlhIRU1PNUw3N0VKVk9CWllSVk1RTjZYRyIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjQ4MDY3OTAyNDY4NDQ5NjgyNTZ9.png',
  conversations:
    'https://cdn.duetapp.net/v1/images/eyJpZCI6IlVKTFc1Rlo1UjVETkFPQTdHMjZOTEtPWE01MkQ3NiIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjYxNjIwNTAxODc0NjU1NTkxNn0.png',
  me: 'https://cdn.duetapp.net/v1/images/eyJpZCI6IlJZSEVSRlIyR1M3RklYNFFTVU01VkQ3QVEyM1dQTiIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE1OTc0MjY2NjQ4MDc1MDEzODl9.webp',
};

export const WingIconMap = {
  ...IconMap,
  swip: 'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik5EMzdJTElGRjU1VkZKMzNPUkhQS01KVjZYV0dPNCIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjk2ODc3ODg2MDg5OTAzNzYzNTB9.png',
};

export const WingIconMapLight = {
  ...IconMapLight,
  swip: 'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik5EMzdJTElGRjU1VkZKMzNPUkhQS01KVjZYV0dPNCIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjk2ODc3ODg2MDg5OTAzNzYzNTB9.png',
};

export const ApplePayMethods = ['applepay', 'ApplePay'];
